// extracted by mini-css-extract-plugin
export default {"header-cell":"tQ5P0Z","headerCell":"tQ5P0Z","cta":"gH6d8L","anonymous":"epedVJ","tax":"zQsiF0","sale":"AXBYM1"};